import PositioningDeviceInfoDetailModal from './positioning-device-info-detail-modal.vue'
export default PositioningDeviceInfoDetailModal
